import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
    {
    // ======================
    // Login
    // ======================
        path: '/',
        component: () => import('./layout/full/Login.vue'),
        children: []
    },
    {
    // ======================
    // Full Layout
    // ======================
        path: '/mainContainer',
        component: () => import('./layout/full/MainContainer.vue'),
        meta: {
            auth: true
        },
    // ======================
    // Theme routes / pages
    // ======================

    children: [
        {
            path: '/',
            redirect: '/generalStates'
        },{
            path: '/generalStates',
            name: 'GeneralStates',
            index: 1,
            component: () => import('./views/GeneralStates.vue'),
            meta:{auth: true}
        },{
            path: '/boxList',
            name: 'BoxList',
            index: 2,
            component: () => import('./views/BoxList.vue')
        },{
            path: '/infoBox',
            name: 'InfoBox',
            index: 3,
            component: () => import('./views/components/box/InfoBox.vue')
        },{
            path: '/registerKey',
            name: 'RegisterKey',
            index: 4,
            component: () => import('./views/RegisterKey.vue')
        },{
            path: '/userRegister',
            name: 'UserRegister',
            index: 5,
            component: () => import('./views/UserRegister.vue')
        },{
            path: '/vehicleList',
            name: 'VehicleList',
            index: 6,
            component: () => import('./views/VehicleList.vue')
        },{
            path: '/generalConfig',
            name: 'GeneralConfig',
            index: 7,
            component: () => import('./views/GeneralConfig.vue')
        },{
            path: '/live',
            name: 'Live',
            index: 8,
            component: () => import('./views/components/utils/Live.vue')
        }



    ]
    },
    // Redirect to starterkit page, if no match found
    {
        path: '*',
        redirect: '/generalStates'
    }
    ]
})

